import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import HeadingContainer from '../heading-container/HeadingContainer';

function Activity() {
  const activities = [
    { title: "Art & Craft", emoji: "🖍️", color: "#FFDDE1" },
    { title: "Music & Dance", emoji: "🎵", color: "#D4FC79" },
    { title: "Outdoor Play", emoji: "🏃‍♂️", color: "#E0C3FC" },
    { title: "Storytelling", emoji: "📖", color: "#FFE29F" },
    { title: "Gardening", emoji: "🌱", color: "#C2E9FB" },
    { title: "Role Play", emoji: "🎭", color: "#FF9A9E" }
  ];

  return (
    <div style={{ backgroundColor: '#ffffff', backgroundImage: 'radial-gradient(#f0f0f0 2px, transparent 2px)', backgroundSize: '30px 30px', minHeight: '80vh', paddingBottom: '80px' }}>
      <HeadingContainer title="Student Activities" />
      <Container maxWidth="lg" sx={{ mt: 6 }}>
        <Grid container spacing={4}>
          {activities.map((act, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Box className="hover-scale" sx={{ 
                background: act.color, 
                borderRadius: '30px', 
                p: 5, 
                textAlign: 'center',
                boxShadow: '0 15px 30px rgba(0,0,0,0.1)',
                transform: `rotate(${i % 2 === 0 ? '-2deg' : '2deg'})`,
                transition: 'all 0.3s ease'
              }}>
                <div style={{ fontSize: '5rem', marginBottom: '20px', filter: 'drop-shadow(0 10px 10px rgba(0,0,0,0.1))' }}>
                  {act.emoji}
                </div>
                <Typography variant="h5" sx={{ fontWeight: 800, fontFamily: 'var(--font-heading)', color: 'rgba(0,0,0,0.7)' }}>
                  {act.title}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}

export default Activity;